import IconButton from 'lib/IconButton';
import { Theme } from 'lib/IconButton/IconButton.types';

interface ActionRendererProps {
  icon: string;
  hasPermission: boolean;
  data: Object;
  onClick: (data: Object) => void;
}

const ActionRenderer = ({
  data = {},
  onClick,
  icon,
  hasPermission,
}: ActionRendererProps): React.ReactElement | null => {
  const onButtonClick = (): void => onClick(data);

  if (!hasPermission) return null;

  return (
    <span className="table-action-button">
      <IconButton name="table-action-button" handleOnClick={onButtonClick} theme={Theme.PLAIN} icon={icon} />
    </span>
  );
};

export default ActionRenderer;
